module.exports = __webpack_public_path__ + "img/RachelRamsay.1595ae9e.webp";